export class TimesheetDetails {
    public approvalStatus: string;
    public date: any;
    public dayparam: string;
    public projectName: string;
    public activityName: string;
    public activityhrs: string;
    public ticketNumber: string;
    public ticketDescription: string;
    public supportGroup: string;
    public totalhrsspents: any;
    public activityDetails: any = [];
    constructor(data: any, businessUnit) {
        this.approvalStatus = data.approvalStatus ? data.approvalStatus.status : '';
        this.date = data.dateDetails.date ? new Date(data.dateDetails.date) : '';
        this.dayparam = this.date != '' ? this.date.getDate() : '';
        if (data.projectDetails.length > 0) {
            let totalhrs = 0;
            for (let i = 0; i < data.projectDetails.length; i++) {
                this.projectName = data.projectDetails[i].projectname ? data.projectDetails[i].projectname : '';
                if (businessUnit === 'ipdo' || businessUnit === 'biologics' || businessUnit === 'chinateam' || businessUnit === 'aps') {
                    totalhrs = totalhrs + this.convertHoursToMins(data.projectDetails[i].totalHrs);
                } else if (businessUnit === 'accenture') {
                    totalhrs = totalhrs + parseFloat(data.projectDetails[i].totalHrs);
                }
                if (data.projectDetails[i].activity_hrs.length > 0) {
                    for (let j = 0; j < data.projectDetails[i].activity_hrs.length; j++) {
                        this.activityName = data.projectDetails[i].activity_hrs[j].activityName;
                        this.activityhrs = data.projectDetails[i].activity_hrs[j].FilledHrs;
                        this.ticketNumber = data.projectDetails[i].activity_hrs[j].ticketNumber;
                        this.ticketDescription = data.projectDetails[i].activity_hrs[j].ticketDescription ? data.projectDetails[i].activity_hrs[j].ticketDescription : '';
                        this.supportGroup = data.projectDetails[i].activity_hrs[j].supportGroup;
                        this.activityDetails.push({ 'projectName': this.projectName, 'activityName': this.activityName, 'filledhrs': this.activityhrs, 'supportGroup': this.supportGroup, 'ticketNumber': this.ticketNumber, 'ticketDescription': this.ticketDescription });
                    }
                }
            }
            if (businessUnit === 'ipdo' || businessUnit === 'biologics' || businessUnit === 'chinateam' || businessUnit === 'aps') {
                this.totalhrsspents = this.convertMinsToHrsMins(totalhrs);

             } else if (businessUnit === 'accenture') {
                this.totalhrsspents = totalhrs;
            }
        }
    }

    convertHoursToMins(hrs) {
        const a = hrs.toString().split(':');
        let minutes = 0;
        if (a[1]) {
          minutes = (+(a[0])) * 60 + (+a[1]);
        } else {
           minutes = (+(Number(a[0]))) * 60;
        }
        return minutes;
    }

    convertMinsToHrsMins(mins) {
        let h: any = Math.floor(mins / 60);
        let m: any = mins % 60;
        m = Math.round(m);
        const hrs = h < 10 ? '0' + h : h;
        const mns = m < 10 ? '0' + m : m;
        return `${hrs}:${mns}`;
    }
}

export class ApproveAll {
    public weeknumber: number;
    // public timeSheetDetail: ApproveDetail[];
    public timeSheetDetail: Array<any>;
    public rmcode: number;

    constructor(data: any = {}) {
        this.weeknumber = data.weeknumber || null;
        // const timeDetail: ApproveDetail[] = [];
        // (data.timeSheetDetail) ? timeDetail.push(new ApproveDetail(data.timeSheetDetail)) : timeDetail.push(new ApproveDetail({}));
        // this.timeSheetDetail = timeDetail;
        this.timeSheetDetail = [];
        this.rmcode = null;
    }
}

export class ApproveDetail {
    public empno: string;
    public datetoApprove: Array<any>;
    constructor(data: any = {}) {
        this.empno = data.empno || '';
        this.datetoApprove = data.datetoApprove || [];
    }
}

export class ApprovalList {
    public employeeName: string;
    public employeenumber: string;
    public buttondisabled: boolean = false;
    public buttonText: string = 'Approve';
    public timesheetDetails: any = [];
    public days: Array<any> = [];
    public dayPopUp: Array<any> = [];
    public showDaypopUpFlag: Array<boolean> = [];
    public dateDetails: any;
    public statusCount: number = 0;
    public dayLeave: Array<string> = [];
    constructor(data: any, businessUnit) {
        this.dateDetails = data.timesheetDetails ? data.timesheetDetails : '';
        this.employeeName = data.employeeDetails ? data.employeeDetails.Empname : '';
        this.employeenumber = data.employeeDetails ? data.employeeDetails.Empno : '';
        if (data.timesheetDetails.length > 0) {
            for (let i = 0; i < data.timesheetDetails.length; i++) {
                this.timesheetDetails.push(new TimesheetDetails(data.timesheetDetails[i], businessUnit));
            }
        }
        for (let i = 0; i < 7; i++) {
            if (businessUnit === 'ipdo' || businessUnit === 'biologics' || businessUnit === 'chinateam' || businessUnit === 'aps') {
                this.days.push('00:00');
            } else if (businessUnit === 'accenture') {
                this.days.push(0);
            }
            this.showDaypopUpFlag.push(false);
            this.dayLeave.push('');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-approvals/timesheet-approvals.ts